import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFi from '@angular/common/locales/fi';
import localeSv from '@angular/common/locales/sv';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { I18nModule, UserAuthModule } from '@spartacus/core';
import { AppRoutingModule, BaseStorefrontModule, StorefrontComponentModule } from '@spartacus/storefront';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';

import { environment } from '../environments/environment';

import { FeaturesModule } from './features/features.module';

// Here register all the locales that will be in use for Dates in the project
registerLocaleData(localeFi, 'fi');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeSv, 'sv');

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        UserAuthModule,
        StorefrontComponentModule,
        BaseStorefrontModule,
        //  BrowserModule.withServerTransition({appId: 'spartacus-app'}),
        AppRoutingModule,
        FeaturesModule,
        I18nModule,
        GoogleTagManagerModule.forRoot({
            id: environment.googleManager.id,
        }),
        !environment.production
            ? StoreDevtoolsModule.instrument({
                  maxAge: 25,
                  connectInZone: true,
              })
            : [],
    ],
    providers: [
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha.siteKey,
        },
    ],
})
export class AppModule {}
